import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader as contactLoader } from '../contact/i18n-loader';
import { i18nLoader as editCapabilitySuggestLoader } from '../edit-capability-suggest/i18n-loader';
import { i18nLoader as editDocumentsLoader } from '../edit-documents/i18n-loader';
import { i18nLoader as editGalleryLoader } from '../edit-gallery/i18n-loader';
import { i18nLoader as editMachineParkLoader } from '../edit-machine-park/i18n-loader';
import { i18nLoader as editProjectRefsLoader } from '../edit-project-references/i18n-loader';
import { i18nLoader as editVirtualTourLoader } from '../edit-virtual-tour/i18n-loader';
import { i18nLoader as editLoader } from '../edit/i18n-loader';
import { i18nLoader as listLoader } from '../list/i18n-loader';
import { i18nLoader as newFactoryModalLoader } from '../new-factory-modal/i18n-loader';
import { i18nLoader as viewLoader } from '../view/i18n-loader';

const editScopes = [
  { scope: 'shared-factory-edit', alias: 'factoryEdit', loader: editLoader },
  {
    scope: 'shared-factory-edit-capability-suggest',
    alias: 'factoryCapabilitySuggest',
    loader: editCapabilitySuggestLoader,
  },
  {
    scope: 'shared-factory-edit-documents',
    alias: 'factoryEditDocuments',
    loader: editDocumentsLoader,
  },
  {
    scope: 'shared-factory-edit-gallery',
    alias: 'factoryEditGallery',
    loader: editGalleryLoader,
  },
  {
    scope: 'shared-factory-edit-machine-park',
    alias: 'factoryEditMachinePark',
    loader: editMachineParkLoader,
  },
  {
    scope: 'shared-factory-edit-virtual-tour',
    alias: 'factoryEditVirtualTour',
    loader: editVirtualTourLoader,
  },
  {
    scope: 'shared-factory-edit-project-references',
    alias: 'factoryEditProjectRefs',
    loader: editProjectRefsLoader,
  },
] as const;

/** All edit sub-scopes plus contact modal translations. */
export function provideFactoryEditI18n(): Provider {
  return provideTranslocoScope(...editScopes, {
    scope: 'shared-factory-contact',
    alias: 'factoryContact',
    loader: contactLoader,
  });
}

/** Public factory profile plus document category/status labels shared with edit. */
export function provideFactoryViewI18n(): Provider {
  return provideTranslocoScope(
    { scope: 'shared-factory-view', alias: 'factoryView', loader: viewLoader },
    {
      scope: 'shared-factory-edit-documents',
      alias: 'factoryEditDocuments',
      loader: editDocumentsLoader,
    }
  );
}

/** Company factory card: list status, view badge, edit actions. */
export function provideFactoryCardI18n(): Provider {
  return provideTranslocoScope(
    { scope: 'shared-factory-list', alias: 'factoryList', loader: listLoader },
    { scope: 'shared-factory-view', alias: 'factoryView', loader: viewLoader },
    { scope: 'shared-factory-edit', alias: 'factoryEdit', loader: editLoader }
  );
}

/** Factory list page plus new-factory modal. */
export function provideFactoryListI18n(): Provider {
  return provideTranslocoScope(
    { scope: 'shared-factory-list', alias: 'factoryList', loader: listLoader },
    {
      scope: 'shared-factory-new-modal',
      alias: 'factoryNewModal',
      loader: newFactoryModalLoader,
    }
  );
}
